import {makeAutoObservable, makeObservable, observable, action} from 'mobx';
// https://mobx.js.org/defining-data-stores.html

export default class UIStore {
    isRedirected = false;
    isPanelOpened = false;
    isPanelExtended = false;
    isCreationMode = false;
    isConsultingMode = false;
    isConsultingModeMessagesInterServices = false;
    isConsultingModePlanningActions = false;
    isConsultingModeTableauBlanc = false;
    isConsultingIndicateurWidget = false;
    isConsultingConsignesWidget = false;
    isConsultingPhotosWidget = false;
    isConsultingModeRSP = false;
    lastPAClose = 0;  // timestamp, incremented each time PA full screen closes
    isDragging = false;
    isParametresOpen = false;
    idWidgetShow = "";
    urlWidgetShow = "";
    menuBurger = true;
    displayEditMode = true;
    isDeleteModeWidget = false;
    showBtnDeleteWidget = true;

    disableBtnBack = true

    constructor() {
        // makeAutoObservable
        // https://mobx.js.org/observable-state.html
        makeAutoObservable(this);
    }

    setDragging(dragging) {
        this.isDragging = dragging;
    }

    openPanel() {
        this.isPanelOpened = true;
        this.isPanelExtended = false;
        this.isConsultingMode = false;
        this.isConsultingModeMessagesInterServices = false;
        this.isConsultingModePlanningActions = false;
        this.lastPAClose = Date.now();
        this.isConsultingIndicateurWidget = false;
        this.isConsultingConsignesWidget = false;
        this.isConsultingPhotosWidget = false;
        this.isConsultingModeRSP = false;
        this.displayEditMode = true;
        this.closeDeleteModeWidget();
    }

    closePanel() {
        this.isPanelOpened = false;
        this.isCreationMode = false;
        this.isPanelExtended = false;
        this.displayEditMode = true;
    }

    retourEditeur() {
        this.isPanelOpened = true;
        this.isCreationMode = false;
        this.isParametresOpen = false;
        this.isPanelExtended = false;
        this.displayEditMode = true;
        this.showBtnDeleteWidget = true;
        this.disableBtnBack = true;
    }

    openCreationMode() {
        this.isCreationMode = true;
        this.isDragging = false;
        this.showBtnDeleteWidget = false;
        this.disableBtnBack = false;
    }

    closeCreationMode() {
        this.isCreationMode = false;
    }

    openConsultingIndicateurWidget() {
        this.menuBurger = false;
        this.isConsultingIndicateurWidget = true;
        this.displayEditMode = false;
    }

    closeConsultingIndicateurWidget() {
        this.backHome();
    }

    openConsultingMode(idWidget, urlWidget) {
        this.isPanelOpened = false;
        this.idWidgetShow = idWidget;
        this.isConsultingMode = true;
        this.isConsultingModeMessagesInterServices = false;
        this.isConsultingModePlanningActions = false;
        this.lastPAClose = Date.now();
        this.isConsultingIndicateurWidget = false;
        this.menuBurger = false;
        if (urlWidget) {
            this.urlWidgetShow = urlWidget;
        } else {
            this.urlWidgetShow = "";
        }

    }

    openConsultingModeMessagesInterServices() {
        this.isPanelOpened = false;
        this.isConsultingMode = false;
        this.isConsultingModeMessagesInterServices = true;
        this.isConsultingModePlanningActions = false;
        this.lastPAClose = Date.now();
        this.menuBurger = false;
        this.displayEditMode = false;
    }

    openConsultingModePlan2do(PlanningActionsStore, token, idWidget, idPlanning, view) {
        this.isPanelOpened = false;
        this.isConsultingMode = false;
        this.isConsultingModeMessagesInterServices = false;
        this.menuBurger = false;
        this.isConsultingModePlanningActions = true;
        this.isConsultingModeTableauBlanc = false;
        this.displayEditMode = false;
        PlanningActionsStore.initialize(token, idWidget, idPlanning, view, /* soft= */ true);
    }


    openConsultingModeTableauBlanc(TableauBlancStore, token, idWidget) {
        this.isPanelOpened = false;
        this.isConsultingMode = false;
        this.isConsultingModeMessagesInterServices = false;
        this.menuBurger = false;
        this.isConsultingModePlanningActions = false;
        this.lastPAClose = Date.now();
        this.isConsultingModeTableauBlanc = true;
        this.displayEditMode = false;
        TableauBlancStore.initialize(token, idWidget);
    }

    openConsultingConsignes() {
        this.isPanelOpened = false;
        this.isConsultingMode = false;
        this.isConsultingConsignesWidget = true;
        this.menuBurger = false;
        this.displayEditMode = false;
    }

    openConsultingBibliothequeImages() {
        this.isPanelOpened = false;
        this.isConsultingMode = false;
        this.isConsultingPhotosWidget = true;
        this.menuBurger = false;
        this.displayEditMode = false;
    }

    openConsultingModeRSP(RspStore, token, idWidget) {
        this.isPanelOpened = false;
        this.isConsultingMode = false;
        this.isConsultingModeMessagesInterServices = false;
        this.menuBurger = false;
        this.isConsultingModePlanningActions = false;
        this.lastPAClose = Date.now();
        this.isConsultingModeTableauBlanc = false;
        this.isConsultingModeRSP = true;
        this.displayEditMode = false;
        RspStore.initialize(token, idWidget);
        RspStore.fetchProblemes();
    }
    closeConsultingMode() {
        console.log("TRIGGERRED closeConsultingMode");
        this.backHome();
    }

    backHome() {
        this.isPanelOpened = false;
        this.isPanelExtended = false;
        this.isCreationMode = false;
        this.isConsultingMode = false;
        this.isConsultingModeMessagesInterServices = false;
        this.isConsultingModePlanningActions = false;
        this.lastPAClose = Date.now();
        this.isConsultingModeTableauBlanc = false;
        this.isConsultingIndicateurWidget = false;
        this.isConsultingConsignesWidget = false;
        this.isConsultingPhotosWidget = false;
        this.isConsultingModeRSP = false;
        this.isDragging = false;
        this.lastPAClose = Date.now();
        this.idWidgetShow = "";
        this.urlWidgetShow = "";
        this.menuBurger = true;
        this.isParametresOpen = false;
        this.displayEditMode = true;
        this.showBtnDeleteWidget = true;
        this.closeDeleteModeWidget();
    }

    backNivOAfterAddPhidget() {
        console.log("TRIGGERRED ws::backNivOAfterAddPhidget", this.isPanelExtended);
        this.isCreationMode = false;
        this.isPanelExtended = true; // Assurez-vous que cette ligne est atteinte
        console.log("ws::Updated isPanelExtended:", this.isPanelExtended);
    }

    openParametres() {
        this.isParametresOpen = true;
        this.displayEditMode = true;
        this.isPanelExtended = false;
        this.showBtnDeleteWidget = false;
        this.disableBtnBack = false;
    }

    openDeleteModeWidget() {
        this.isDeleteModeWidget = true;
    }

    closeDeleteModeWidget() {
        this.isDeleteModeWidget = false;
    }

}
